import {GET_HASH_START, GET_HASH_SUCCESS, GET_HASH_FAIL, GET_HASH_RESET} from './constants';
import {GetHashActions, GetHashState} from './types';

const initialState: GetHashState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetHashActions,
): GetHashState => {
  switch (action.type) {
    case GET_HASH_START:
      return {
        ...initialState,
        loading: true,
      };
    case GET_HASH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_HASH_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_HASH_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
